export default __webpack_public_path__ + "static/media/Coin2.86e79a6a.webp";